import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-percent-input',
  templateUrl: 'percent-input.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PercentInputComponent),
      multi: true
    }
  ]
})
export class PercentInputComponent implements ControlValueAccessor {
  constructor() {}

  percent: number = 0; // for display purpose
  @Input() value: any; // for binding purpose
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() allowEdit = true;

  onChange: any = () => {};
  onTouched: any = () => {};

  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }

  writeValue(value: number): void {
    this.value = value;
    this.percent = value * 100;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  valueChanged(percent: any) {
    this.value = percent / 100;
    this.onChange(this.value);
  }
}
